import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const VendorDepositFirstConfirmModal = ({
    isOpen,
    onCancel,
    onConfirm,
}) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[80] flex items-center justify-center p-4"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="deposit-first-confirm-title"
            aria-describedby="deposit-first-confirm-description"
        >
            <button
                type="button"
                className="absolute inset-0 bg-gray-900/40"
                aria-label="Close"
                onClick={onCancel}
            />
            <div className="relative z-[81] w-full max-w-lg rounded-lg border border-border bg-white p-6 shadow-lg">
                <div className="flex flex-col gap-2">
                    <h2
                        id="deposit-first-confirm-title"
                        className="text-lg font-semibold flex items-center gap-2"
                    >
                        <ExclamationTriangleIcon className="w-5 h-5 text-amber-500" />
                        Are you sure?
                    </h2>
                    <p
                        id="deposit-first-confirm-description"
                        className="text-muted-foreground text-[13px] leading-relaxed"
                    >
                        Setting Deposit 1 to 100% means finance will pay the full invoice amount upfront. With overseas suppliers, this is almost never correct — there should always be split payment terms (e.g., 30% deposit, 70% on shipment). Only proceed if this vendor genuinely requires full prepayment.
                    </p>
                </div>
                <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end mt-6">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all border bg-transparent shadow-xs hover:bg-gray-100 rounded-md h-9 px-4 text-sm border-border"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all rounded-md h-9 px-4 text-sm bg-amber-600 hover:bg-amber-700 text-white"
                    >
                        Yes, set to 100%
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VendorDepositFirstConfirmModal;
